import { render } from "./ScriptTagsComp.vue?vue&type=template&id=643f4c5e&ts=true"
import script from "./ScriptTagsComp.vue?vue&type=script&lang=ts"
export * from "./ScriptTagsComp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__